import React, { useState } from 'react';
import { HouseLine, Archive, MapPin, Wallet, Flag, CaretRight, ArrowCounterClockwise, Copy, Trash } from '@phosphor-icons/react';
import { ActionMenu } from '../ui/ActionMenu';
import { ConfirmDialog } from '../ui/ConfirmDialog';
import { formatBudget, AnuntHistoryEntry } from '../../lib/utils';
interface AnuntHistoryCardProps {
  entry: AnuntHistoryEntry;
  onOpen: (id: string) => void;
  onRestore?: (id: string) => void;
  onDuplicate?: (id: string) => void;
  onDelete?: (id: string) => void;
}
function formatClosedAt(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('ro-RO', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  } catch {
    return '';
  }
}
export function AnuntHistoryCard({
  entry,
  onOpen,
  onRestore,
  onDuplicate,
  onDelete
}: AnuntHistoryCardProps) {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const isSucces = entry.status === 'succes';
  const closedAtLabel = formatClosedAt(entry.closedAt);
  const snap = entry.anuntSnapshot;
  return <>
      <article onClick={() => onOpen(entry.id)} className="group rounded-2xl bg-dark-2 border border-dark-3 hover:border-dark-4 cursor-pointer transition-colors relative" data-id="element-121">
        <div className="px-5 py-4 flex items-start gap-4" data-id="element-122">
          <div className={'w-10 h-10 rounded-xl inline-flex items-center justify-center shrink-0 ' + (isSucces ? 'bg-lime-5 border border-lime-4' : 'bg-dark-3 border border-dark-4')} data-id="element-123">
            {isSucces ? <HouseLine size={18} weight="fill" className="text-lime-1" data-id="element-124" /> : <Archive size={16} weight="regular" className="text-light-2" data-id="element-125" />}
          </div>

          <div className="min-w-0 flex-1" data-id="element-126">
            <div className="flex items-center gap-2 flex-wrap" data-id="element-127">
              <h3 className="text-sm font-semibold text-light-1 truncate" data-id="element-128">
                {isSucces ? entry.succesCounterpartyName ? `Închiriat cu ${entry.succesCounterpartyName}` : 'Anunț închis cu succes' : 'Anunț arhivat'}
              </h3>
              <span className={'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium ' + (isSucces ? 'bg-lime-5 text-lime-1 border border-lime-4' : 'bg-dark-3 text-light-3 border border-dark-4')} data-id="element-129">
                {isSucces ? 'Succes' : 'Arhivat'}
              </span>
            </div>

            <p className="text-xs text-light-4 mt-0.5" data-id="element-130">
              {closedAtLabel ? `Închis pe ${closedAtLabel}` : ''}
              {isSucces && entry.associatedOfferIds.length > 0 ? ` · ${entry.associatedOfferIds.length} oferte` : ''}
            </p>

            <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-light-3" data-id="element-131">
              {snap.neighborhoods && <span className="inline-flex items-center gap-1.5" data-id="element-132">
                  <MapPin size={12} weight="regular" data-id="element-133" />
                  {snap.neighborhoods}
                </span>}
              {snap.budgetMaxEur > 0 && <span className="inline-flex items-center gap-1.5" data-id="element-134">
                  <Wallet size={12} weight="regular" data-id="element-135" />
                  max {formatBudget(snap.budgetMaxEur)}
                </span>}
              {snap.moveInDate && <span className="inline-flex items-center gap-1.5" data-id="element-136">
                  <Flag size={12} weight="regular" data-id="element-137" />
                  {snap.moveInDate}
                </span>}
            </div>
          </div>

          <div className="flex items-center gap-1 shrink-0" onClick={e => e.stopPropagation()} data-id="element-138">
            <ActionMenu triggerAriaLabel="Acțiuni anunț arhivat" items={[...(onRestore ? [{
            label: 'Restaurează',
            icon: <ArrowCounterClockwise size={18} weight="regular" data-id="element-140" />,
            onClick: () => onRestore(entry.id)
          }] : []), ...(onDuplicate ? [{
            label: 'Duplichează',
            icon: <Copy size={18} weight="regular" data-id="element-141" />,
            onClick: () => onDuplicate(entry.id)
          }] : []), ...(onDelete ? [{
            label: 'Șterge definitiv',
            icon: <Trash size={18} weight="regular" data-id="element-142" />,
            onClick: () => setConfirmDelete(true),
            destructive: true
          }] : [])]} data-id="element-139" />
            <CaretRight size={14} weight="bold" className="text-light-4 group-hover:text-light-2 transition-colors" data-id="element-143" />
          </div>
        </div>
      </article>

      <ConfirmDialog open={confirmDelete} title="Ștergi definitiv acest anunț?" description="Anunțul și ofertele asociate vor fi eliminate permanent. Această acțiune nu poate fi anulată." confirmLabel="Da, șterge" cancelLabel="Anulează" variant="danger" dashboardOffset onConfirm={() => {
      setConfirmDelete(false);
      onDelete && onDelete(entry.id);
    }} onCancel={() => setConfirmDelete(false)} data-id="element-144" />
    </>;
}